<template>
    <a-spin :spinning="loading">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form layout="inline" :autoFormCreate="(form) => {
                    this.form = form;
                }
                    ">
                    <a-row :gutter="48">
                        <a-col :md="12" :sm="24">
                            <a-form-item label="必中卡号">
                                <a-input placeholder="请扫必中卡二维码" disabled v-model="formData.optionalCardNo" />
                            </a-form-item>
                            <template v-if="userInfo">
                                <a-form-item label="用户uid">
                                    <a-input placeholder="请扫用户码" disabled v-model="formData.uid" />
                                </a-form-item>
                                <div style="color:red;font-size:24px">执行操作前，请务必核对用户ID是否匹配！</div>
                                <a-form-item label="用户ID">
                                    <span style="font-size:36px;font-weight: bold;">{{ userInfo.uid }}</span>
                                </a-form-item>
                                <a-form-item label="用户头像" style="height:128px">
                                    <img class="avatar" :src="userInfo.avatar" alt="avatar" width=128 height=128
                                        style="border-radius:64px;" />
                                </a-form-item>
                                <a-form-item label="用户昵称">
                                    {{ userInfo.nickname }}
                                </a-form-item>
                                <a-form-item label="必中卡状态">
                                    <span :style="`color:${optionalCard.status ? '#f33' : 'green'}`">{{ optionalCard.status |
                                        getOptionalCardStatusText }}</span>
                                </a-form-item>
                            </template>
                        </a-col>
                    </a-row>
                    <a-button v-if="userInfo" type="primary" @click="submit" :disabled="!!optionalCard.status">核销</a-button>
                    <a-button v-if="userInfo" style="margin-left:12px"
                        @click="userInfo = null; optionalCard = null; formData = { uid: '', optionalCardNo: '' }">重新扫码</a-button>
                </a-form>
            </div>
        </a-card>
    </a-spin>
</template>
<script>

import { Modal } from 'ant-design-vue'
import { getOptionalCard, UseOptionalCardStatus } from '@/api/purchase'
import HandleUserAbnormal from './HandleUserAbnormal'

export default {
    filters: {
        getOptionalCardStatusText(val) {
            let status = [
                "未使用",
                "已使用",
            ]
            return status[val]
        }
    },
    mixins: [HandleUserAbnormal],
    name: 'Doll',
    data() {
        return {
            userInfo: null,
            optionalCard: null,
            formData: {
                uid: "",
                optionalCardNo: "",
            },
            key: "",
            keyTimeID: 0,
            loading: false,
        }
    },
    watch: {
        userInfo: {
            handler(val) {
                if (!this.userInfo) {
                    this.bindWindowScan()
                } else {
                    this.removeWindowScan()
                }
            },
            immediate: true
        }
    },
    methods: {
        submit() {
            Modal.confirm({
                title: '确认核销',
                content: `确认给用户 ${this.userInfo.nickname} 核销必中卡吗？`,
                okText: '确认',
                cancelText: '取消',
                onOk: () => {
                    this.loading = true
                    UseOptionalCardStatus(this.optionalCard.id).then(res => {
                        this.$message.success('操作成功')
                        this.optionalCard.status = 1
                    })
                        .finally(() => {
                            this.loading = false
                        })
                },
            });
        },
        handleScan(e) {
            if (this.keyTimeID) {
                clearTimeout(this.keyTimeID)
            }
            this.keyTimeID = setTimeout(() => {
                this.key = ""
            }, 50)
            this.key += e.key
            if (this.key.indexOf("Enter") > -1) {
                this.key = this.key.replace("Enter", "")
                if (/[^\d]/.test(this.key) || this.key.length < 8 || this.key == "") {
                    return
                }
                this.getUserInfo(this.key)
            }
        },
        bindWindowScan() {
            window.addEventListener('keydown', this.handleScan);
        },
        removeWindowScan() {
            window.removeEventListener('keydown', this.handleScan);
        },
        getUserInfo(key) {
            this.loading = true
            getOptionalCard(key).then(res => {
                const { uid, nickname, avatar, id, doll, is_abnormal } = res.user;
                if (is_abnormal) {
                    this.loading = false
                    this.showAbnormalModal()
                    return
                }
                this.userInfo = {
                    id,
                    uid,
                    nickname,
                    avatar,
                    doll,
                }
                this.optionalCard = res
                this.formData.uid = uid
                this.formData.optionalCardNo = key
            })
                .finally(() => {
                    this.loading = false
                })
        }
    },
    mounted() {

    },
    beforeDestroy() {
        this.removeWindowScan()
    }
}
</script>